import React, { useEffect, useState } from 'react';
import { InlineWidget } from 'react-calendly';
import { CloseThin, LogoText2 } from '@/resources/assets/images';
import { useHistory } from 'react-router-dom';
import { useUpdateOnboardingStatus } from '@/modules/onboarding/hooks/useUpdateOnboardingStatus';

type CalendlyModalProps = {
	onClose: () => void;
	calendlyUrl: string;
};

const CalendlyModal: React.FC<CalendlyModalProps> = ({
	onClose,
	calendlyUrl
}) => {
	const [hasEnteredDatePicker, setHasEnteredDatePicker] = useState(false);
	const history = useHistory();
	const { mutateAsync: updateOnboardingStatus } = useUpdateOnboardingStatus();

	useEffect(() => {
		const handleMessage = (e: MessageEvent) => {
			if (e.origin !== 'https://calendly.com') return;
			const { event } = e.data;

			if (event === 'calendly.event_type_viewed') {
				setHasEnteredDatePicker(true);
			}
			if (event === 'calendly.event_scheduled') {
				updateOnboardingStatus({
					status: 'completed'
				}).then(() => {
					sessionStorage.removeItem('suppressOnboardingRedirect');
				});
				history.push('/search-businesses');
			}
		};

		window.addEventListener('message', handleMessage);
		return () => window.removeEventListener('message', handleMessage);
	}, []);

	return (
		<div className="fixed inset-0 z-[200] flex items-center justify-center bg-black bg-opacity-70 p-4">
			<div className="relative h-full max-h-[43.875rem] w-full max-w-[42rem] overflow-y-auto rounded-xl border border-dm-gray bg-dm-black">
				<div className="flex h-full w-full flex-col gap-8 p-6 sm:p-[2rem_2.5rem_1.5rem_2rem]">
					<button type="button" className="absolute right-8 top-4">
						<CloseThin
							className="h-4 w-4 text-gray-100"
							onClick={onClose}
						/>
					</button>

					<LogoText2 />

					<div className="flex flex-col gap-4">
						<h2 className="font-barlow text-xl font-semibold leading-6 text-dm-white">
							{hasEnteredDatePicker
								? '🚀 Ready to move faster?'
								: 'Explore What Premium Can Do for You'}
						</h2>

						<p className="font-barlow text-base font-normal leading-[1.188rem] text-dm-white">
							{hasEnteredDatePicker
								? 'Book a personlized session to unlock everything and learn how top users are getting leads with Resquared!'
								: 'You’re almost there. The most powerful features—like sending outreach emails—are available in our premium plans, built for teams like yours.'}
						</p>
					</div>

					<div className="min-h-0 flex-grow">
						<div className="h-full w-full overflow-hidden rounded-xl">
							<InlineWidget
								url={calendlyUrl}
								styles={{
									height: '100%',
									width: '100%'
								}}
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default CalendlyModal;
